import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import {
  CreateDairyYieldScanRequest,
  CreateDairyYieldScanResponse,
  DairyYieldScanQuestionnaire,
  DairyYieldScanSummary,
  UpdateDairyYieldScanActionPlanRequest,
} from '../models/dairy-yield-scan.models';

@Injectable({ providedIn: 'root' })
export class DairyYieldScanService {
  private readonly environment = inject(EnvironmentInjector);
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${this.environment.APIM_BASE_URL}/herd-v2-service`;

  getQuestionnaire(): Observable<DairyYieldScanQuestionnaire> {
    return this.http.get<DairyYieldScanQuestionnaire>(
      `${this.baseUrl}/dairy-yield-scans/questionnaire`,
    );
  }

  createScan(request: CreateDairyYieldScanRequest): Observable<CreateDairyYieldScanResponse> {
    return this.http.post<CreateDairyYieldScanResponse>(
      `${this.baseUrl}/dairy-yield-scans`,
      request,
    );
  }

  getScanSummary(scanId: string): Observable<DairyYieldScanSummary> {
    return this.http.get<DairyYieldScanSummary>(
      `${this.baseUrl}/dairy-yield-scans/${encodeURIComponent(scanId)}/summary`,
    );
  }

  updateActionPlan(
    scanId: string,
    request: UpdateDairyYieldScanActionPlanRequest,
  ): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/dairy-yield-scans/${encodeURIComponent(scanId)}/action-plan`,
      request,
    );
  }
}
